import React from "react";
import { ButtonBase, Grid } from "@mui/material";
import { animateScroll as scroll } from "react-scroll";

const ProductLogo = ({ navigate }) => {
  const avatar = "/bbbw.png";

  const clickButton = () => {
    window.open("https://nataliaki.eu", "_blank", "noopener,noreferrer");
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ width: "100%", marginTop: 10 }}
    >
      <ButtonBase disableRipple onClick={clickButton}>
        <img width="120px" alt="Logo_BBQ" src={avatar} />
      </ButtonBase>
    </Grid>
  );
};

export default ProductLogo;
